export default __webpack_public_path__ + "static/char-thumb-02-e7c2ee519d5b0ede01255591465ca2e4.png";